import React from 'react';

const FriendIcon = ({ width = 20, height = 20, className = '' }) => {
	return (
		<svg
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 512 512"
			style={{ enableBackground: 'new 0 0 512 512' }}
			xmlSpace="preserve"
			width={width}
			height={height}
			className={className}
		>
			<g>
				<g>
					<path
						d="M484.719,168.958L431.025,53.042L180.782,168.958H0v290h330.538l2.101-12.517c3.646-21.719,22.302-37.483,44.361-37.483
c22.059,0,40.716,15.764,44.361,37.483l2.101,12.517H512v-290H484.719z M140,398.958H60v-30h80V398.958z M210,318.958H60v-30h150
V318.958z M240,258.958H60v-30h180V258.958z M423.462,168.958l-2.101,12.517c-3.646,21.719-22.302,37.483-44.361,37.483
c-22.059,0-40.716-15.764-44.361-37.483l-2.101-12.517h-78.379l164.255-76.084l35.243,76.084H423.462z"
						fill="currentcolor"
					/>
				</g>
			</g>
		</svg>
	);
};

export default FriendIcon;

